export default __webpack_public_path__ + "static/media/4.2bb9f0f7.jpg";